<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import NewPixel from './NewPixel.vue';
import EditPixel from './EditPixel.vue';
import PixelRow from './PixelRow.vue';
import SettingsPageLayout from 'dashboard/components-next/Settings/SettingsPageLayout.vue';
import SettingsTable from 'dashboard/components-next/Settings/SettingsTable.vue';

export default {
  components: {
    SettingsPageLayout,
    SettingsTable,
    NextButton,
    NewPixel,
    EditPixel,
    PixelRow,
  },
  data() {
    return {
      showAddPopup: false,
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedPixel: {},
    };
  },
  computed: {
    ...mapGetters({
      records: 'metaCapiPixels/getPixels',
      uiFlags: 'metaCapiPixels/getUIFlags',
    }),
    tableHeaders() {
      return [
        this.$t('META_CAPI_PIXELS.LIST.TABLE_HEADER.NAME'),
        this.$t('META_CAPI_PIXELS.LIST.TABLE_HEADER.STATUS'),
        this.$t('META_CAPI_PIXELS.LIST.TABLE_HEADER.ACTIONS'),
      ];
    },
  },
  mounted() {
    this.$store.dispatch('metaCapiPixels/get');
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    openDeletePopup(pixel) {
      this.showDeleteConfirmationPopup = true;
      this.selectedPixel = pixel;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    openEditPopup(pixel) {
      this.showEditPopup = true;
      this.selectedPixel = pixel;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    confirmDeletion() {
      this.closeDeletePopup();
      this.deletePixel(this.selectedPixel.id);
    },
    async deletePixel(id) {
      try {
        await this.$store.dispatch('metaCapiPixels/delete', id);
        useAlert(this.$t('META_CAPI_PIXELS.DELETE.API.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(this.$t('META_CAPI_PIXELS.DELETE.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <SettingsPageLayout
    :title="$t('META_CAPI_PIXELS.HEADER')"
    :description="$t('META_CAPI_PIXELS.DESCRIPTION')"
  >
    <template #actions>
      <NextButton
        icon="i-lucide-circle-plus"
        :label="$t('META_CAPI_PIXELS.HEADER_BTN_TXT')"
        @click="openAddPopup"
      />
    </template>

    <SettingsTable
      :headers="tableHeaders"
      :is-loading="uiFlags.fetchingList"
      :is-empty="!records.length"
      :empty-message="$t('META_CAPI_PIXELS.LIST.EMPTY')"
    >
      <PixelRow
        v-for="(pixel, index) in records"
        :key="pixel.id"
        :index="index"
        :pixel="pixel"
        @edit="openEditPopup"
        @delete="openDeletePopup"
      />
    </SettingsTable>

    <woot-modal v-model:show="showAddPopup" :on-close="hideAddPopup">
      <NewPixel v-if="showAddPopup" :on-close="hideAddPopup" />
    </woot-modal>

    <woot-modal v-model:show="showEditPopup" :on-close="hideEditPopup">
      <EditPixel
        v-if="showEditPopup"
        :id="selectedPixel.id"
        :value="selectedPixel"
        :on-close="hideEditPopup"
      />
    </woot-modal>

    <woot-delete-modal
      v-model:show="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('META_CAPI_PIXELS.DELETE.CONFIRM.TITLE')"
      :message="
        $t('META_CAPI_PIXELS.DELETE.CONFIRM.MESSAGE', {
          pixelName: selectedPixel.name,
        })
      "
      :confirm-text="$t('META_CAPI_PIXELS.DELETE.CONFIRM.YES')"
      :reject-text="$t('META_CAPI_PIXELS.DELETE.CONFIRM.NO')"
    />
  </SettingsPageLayout>
</template>
